import Fuse from 'fuse.js';
import { useCallback, useMemo } from 'react';
import { flatMenus } from 'src/Shared/Utilities/Menu';
import { useGetMenuQuery } from 'src/app/standaloneSlices/apiSlice';
import { IReportItem } from 'src/feature/Menu/menuModels';
import { UseGetMenuWithFavourite } from './FavouriteReportHooks';

export function useMenu(): IReportItem[] {
  const { data } = useGetMenuQuery();

  const menu = useMemo(() => {
    // if (isBeta()) {
    //   // ['MattersAndClientsMenu', 'TrustMenu', 'OfficeMenu', 'ManagementMenu', 'DashboardMenu'];
    //   const allowedMenuList = ['ManagementMenu', 'MattersAndClientsMenu', 'TrustMenu', 'OfficeMenu'];
    //   return data
    //     ? data.map((item) => {
    //         if (allowedMenuList.includes(item.Name)) {
    //           return item;
    //         } else {
    //           return {
    //             ...item,
    //             SubMenuItems: [],
    //           };
    //         }
    //       })
    //     : [];
    // }
    return data ? data : [];
  }, [data]);
  return menu;
}

export function useFlattenMenu(): IReportItem[] {
  const menu = UseGetMenuWithFavourite();
  return useMemo(() => flatMenus(menu), [menu]);
}

export function useSearch() {
  const data = useFlattenMenu();
  const fuse = useMemo(() => {
    return new Fuse<IReportItem>(data, {
      keys: ['Title', 'ParentNode.Title'],
      includeScore: true,
      shouldSort: true,
      useExtendedSearch: true,
    });
  }, [data]);
  const searchFn = useCallback(
    (key: string) => {
      return fuse.search(key).map((item) => item.item);
    },
    [fuse],
  );
  return searchFn;
}

// export function useMenu() {
//   const favouriteReports = UseGetFavouriteReports();
//   // const menu = useSelector(getMenuData);
//   const menu = useGetMenu();
//   if (favouriteReports?.length) {
//     const favouriteCate: IMenuItem = {
//       Name: 'MyFavouriteReports',
//       Title: 'My Favourite Reports',
//       SubMenuItems: favouriteReports,
//     };
//     return [favouriteCate, ...menu];
//   } else {
//     return menu;
//   }
// }
